import { HDALU_FINISHES, HDALU_TREATMENTS } from "@/utils/content/hdaluLabels";

export type HDAluProps = {
  display: boolean;
  frameOptions: any;
  finish: string;
  treatmentOptions: {
    subcategory: string;
    type: string;
  };
};

export const hdAluProps: HDAluProps = {
  display: false,
  finish: HDALU_FINISHES[0].label,
  frameOptions: {
    dimensions: {
      depth: 1.125,
      face: 0.75,
    },
    label: "White Gallery Frame",
    texture: {
      face: "white",
      hex: "#fffffe",
      preview: "white",
      side: "white",
    },
    type: "",
  },
  treatmentOptions: {
    subcategory: "",
    type: HDALU_TREATMENTS[0],
  },
};
